<template>
	<v-template>
		<v-row>
			<v-col cols="12" class="display-1 text-center">
				Datos de cliente
			</v-col>
		</v-row>
		<v-expand-transition>
			<v-row v-show="cargandoDatosPrellenado">
				<v-col cols="12" class="d-flex justify-center">
					<v-progress-circular :size="150" :width="15" indeterminate color="primary"/>
				</v-col>
				<v-col cols="12" class="text-center">
					Obteniendo datos para prellenar datos de cliente...
				</v-col>
			</v-row>
		</v-expand-transition>
		<v-form v-model="formularioValido" v-show="!cargandoDatosPrellenado">
			<v-row>
				<v-col cols="12" class="title">
					Empresa
				</v-col>
				<v-col cols="12">
					<v-row>
						<v-col cols="12" sm="6">
							<v-text-field v-model="empresa.rut" label="RUT" :rules="[validarRut]"
								hint="Ejemplo: 12345678-9, sin puntos y con guión" append-icon="fingerprint" @paste="pegarEnConfirmacion">
							</v-text-field>
							<v-text-field v-model="empresa.razonSocial" label="Razón social" :rules="[validarDefinido]"
								hint="Ejemplo: VESSI SPA">
							</v-text-field>
							<v-text-field v-model="empresa.giroComercial" label="Giro comercial" :rules="[validarDefinido]"
								hint="Ejemplo: ACTIVIDADES DE CONSULTORÍA DE INFORMÁTICA Y DE GESTIÓN DE INSTALACIONES INFORMÁTICAS">
							</v-text-field>
							<v-text-field v-model="empresa.nombreFantasia" label="Nombre de fantasía">
							</v-text-field>
							<v-select v-model="empresa.tieneBoleta" label="¿Tiene boleta electrónica activa con el SII u otro proveedor?"
								:items="opcionesTieneBoleta" :rules="[validarDefinido]">
							</v-select>
							<v-select v-model="empresa.tiposBoleta" label="Tipos de boleta"
								:items="opcionesTipoBoleta" :rules="[validarDefinido]">
								<template v-slot:append-outer>
									<Ayuda tema="tiposBoleta"/>
								</template>
							</v-select>
						</v-col>
						<v-col cols="12" sm="6">
							<v-text-field v-model="empresa.email" label="Correo electrónico" :rules="[validarEmail]"
							 append-icon="email" @change="$refs.confirmarEmailEmpresa.reset()">
							</v-text-field>
							<v-text-field v-model="confirmarEmailEmpresa" label="Confirme correo electrónico" 
								:rules="[validarConfirmarEmailEmpresa]" append-icon="email" @paste="pegarEnConfirmacion"
								ref="confirmarEmailEmpresa">
							</v-text-field>
							<v-text-field v-model="telefonoEmpresa" label="Teléfono" :rules="[validarTelefono]"
								 append-icon="phone" :prefix="prefijoTelefonos" @change="$refs.confirmarTelefonoEmpresa.reset()">
							</v-text-field>
							<v-text-field v-model="confirmarTelefonoEmpresa" label="Confirme teléfono" 
								:rules="[validarConfirmarTelefonoEmpresa]" append-icon="phone" :prefix="prefijoTelefonos"
								@paste="pegarEnConfirmacion" ref="confirmarTelefonoEmpresa">
							</v-text-field>
							<v-text-field v-model="empresa.direccion" label="Dirección comercial" :rules="[validarDefinido]"
								append-icon="place">
							</v-text-field>
							<v-autocomplete v-model="empresa.region" label="Región" :items="regionesComunas" :rules="[validarDefinido]"
								:loading="cargandoRegionesComunas" @change="empresa.comuna = undefined" item-text="nombre" return-object>
							</v-autocomplete>
							<v-autocomplete v-model="empresa.comuna" label="Comuna" :items="(empresa.region === undefined) ? undefined : empresa.region.comunas" 
								:rules="[validarDefinido]" :disabled="empresa.region === undefined" item-text="nombre" return-object>
							</v-autocomplete>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="12" class="title">
					Representante legal <Ayuda tema="representanteLegal"/>
				</v-col>
				<v-col cols="12">
					<v-row>
						<v-col cols="12" sm="6">
							<v-text-field v-model="representante.rut" label="RUT" :rules="[validarRut]"
								hint="Ejemplo: 12345678-9, sin puntos y con guión" append-icon="fingerprint" @paste="pegarEnConfirmacion">
							</v-text-field>
							<v-text-field v-model="representante.nombres" label="Nombres" :rules="[validarDefinido]" hint="Ejemplo: Marcela Carolina">
							</v-text-field>
							<v-text-field v-model="representante.apellidoPaterno" label="Apellido paterno" :rules="[validarDefinido]" hint="Ejemplo: Fredez">
							</v-text-field>
							<v-text-field v-model="representante.apellidoMaterno" label="Apellido materno" :rules="[validarDefinido]" hint="Ejemplo: Vidal">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6">
							<v-text-field v-model="representante.email" label="Correo electrónico" :rules="[validarEmail]"
							 append-icon="email" @change="$refs.confirmarEmailRepresentante.reset()">
							</v-text-field>
							<v-text-field v-model="confirmarEmailRepresentante" label="Confirme correo electrónico" 
								:rules="[validarConfirmarEmailRepresentante]" append-icon="email" @paste="pegarEnConfirmacion"
								ref="confirmarEmailRepresentante">
							</v-text-field>
							<v-text-field v-model="telefonoRepresentante" label="Teléfono" :rules="[validarTelefono]"
								 append-icon="phone" :prefix="prefijoTelefonos" @change="$refs.confirmarTelefonoRepresentante.reset()">
							</v-text-field>
							<v-text-field v-model="confirmarTelefonoRepresentante" label="Confirme teléfono" 
								:rules="[validarConfirmarTelefonoRepresentante]" append-icon="phone" :prefix="prefijoTelefonos"
								@paste="pegarEnConfirmacion" ref="confirmarTelefonoRepresentante">
							</v-text-field>
							<v-file-input v-model="representante.cedulaAnverso" label="Anverso cédula identidad" :show-size="true"
								append-icon="insert_drive_file" clearable prepend-icon="" :rules="[validarArchivo]"
								:accept="mimeTypesArchivoAceptados.join(',')" ref="inputCedulaAnverso">
								<template v-slot:append>
									<v-btn text @click="abrirDialogoArchivoCedulaAnverso">
										Examinar...
									</v-btn>
								</template>
							</v-file-input>
							<v-file-input v-model="representante.cedulaReverso" label="Reverso cédula identidad" :show-size="true"
								append-icon="insert_drive_file" clearable prepend-icon="" :rules="[validarArchivo]"
								:accept="mimeTypesArchivoAceptados.join(',')" ref="inputCedulaReverso">
								<template v-slot:append>
									<v-btn text @click="abrirDialogoArchivoCedulaReverso">
										Examinar...
									</v-btn>
								</template>
							</v-file-input>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="12" v-show="hayDirecciones">
					<div class="title">
						Direcciones
					</div>
					<div>
						Ingrese las direcciones en que usará el servicio.
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-btn small depressed @click="usarDireccionComercial" v-bind="attrs" v-on="on" color="primary">
									<v-icon left>
										content_copy
									</v-icon>
									Usar dirección comercial
								</v-btn>
							</template>
							<span>
								<b>¿Es su dirección comercial la misma donde utilizará el servicio?</b><br>
								Haga clic aquí para usar la dirección comercial que ya ingresó en los datos de empresa.<br>
								Se copiará a la primera dirección de la lista de direcciones en que usará el servicio.
							</span>
						</v-tooltip>
					</div>
				</v-col>
				<v-col cols="12" v-show="hayDirecciones">
					<v-row v-for="(direccion, i) in direcciones">
						<v-col cols="12" sm="4">
							<v-text-field v-model="direccion.direccion" :label="'Dirección #' + (i + 1)" 
								:rules="[validarDefinido]" append-icon="place">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="4">
							<v-autocomplete v-model="direccion.region" label="Región" :items="regionesComunas" 
								:rules="[validarDefinido]" :loading="cargandoRegionesComunas" @change="direccion.comuna = undefined" item-text="nombre"
								return-object>
							</v-autocomplete>
						</v-col>
						<v-col cols="12" sm="4">
							<v-autocomplete v-model="direccion.comuna" label="Comuna" :items="(direccion.region === undefined) ? undefined : direccion.region.comunas"
								:rules="[validarDefinido]" :disabled="direccion.region === undefined" item-text="nombre" return-object>
							</v-autocomplete>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<v-expand-transition>
				<v-alert outlined type="info" class="my-1" v-show="telefonosIguales" text>
					Los <b>teléfonos</b> de empresa y representante legal que has ingresado <b>son iguales</b>. 
					Se recomienda, de ser posible, que <b>sean distintos</b> para tener más opciones de contacto.
				</v-alert>
			</v-expand-transition>
			<v-expand-transition>
				<v-alert outlined type="info" class="my-1" v-show="emailsIguales" text>
					Los <b>e-mails</b> de empresa y representante legal que has ingresado <b>son iguales</b>. 
					Se recomienda, de ser posible, que <b>sean distintos</b> para tener más opciones de contacto.
				</v-alert>
			</v-expand-transition>
			<v-expand-transition>
				<v-alert outlined type="warning" class="my-1" v-show="archivosCedulaParecenIguales" text>
					Los archivos de <b>anverso de cédula</b> y <b>reverso de cédula</b> parecen ser <b>iguales</b>.
					Por favor verifica que los archivos escogidos efectivamente correspondan al anverso y reverso de la cédula.
					<b>Para hacer efectivo el contrato son necesarias ambas imágenes</b>.
				</v-alert>
			</v-expand-transition>
		</v-form>
	</v-template>
</template>

<script>
import { API } from 'aws-amplify';
import * as RutJs from 'rut.js';
import Ayuda from '@/components/Ayuda';
import * as config from '@/config';

const prefijoTelefonos = '+56';
const pesoMinimoArchivo = 10*1024; // En bytes.
const pesoMaximoArchivo = 10*1024*1024; // En bytes. (10MB, despinoza 02-feb-2021)
const tiposArchivoAceptados = [
	{'mimeType': 'image/jpeg', 'descripcion': 'imagen JPG'},
	{'mimeType': 'image/png', 'descripcion': 'imagen PNG'},
];

export default {
	components: {
		Ayuda
	},
	props: {
		'datosPlan': {
			type: Object,
			default: {},
		},
		'cargandoDatosPrellenado': {
			type: Boolean,
			default: false,
		},
		'datosPrellenado': {
			type: Object,
			default: undefined,
		},
		vendedorAsistente: {
			type: String, // Sólo para inferir si es venta asistida
		},
	},
	data: () => ({
		empresa: {
			rut: undefined,
			razonSocial: undefined,
			giroComercial: undefined,
			nombreFantasia: undefined,
			tieneBoleta: undefined,
			tiposBoleta: undefined,
			email: undefined,
			direccion: undefined,
			comuna: undefined,
			region: undefined,
		},
		representante: {
			rut: undefined,
			nombres: undefined,
			apellidoPaterno: undefined,
			apellidoMaterno: undefined,
			cedulaAnverso: undefined,
			cedulaReverso: undefined,
			email: undefined,
		},
		regionesComunas: [],
		cargandoRegionesComunas: false,
		telefonoEmpresa: undefined,
		confirmarTelefonoEmpresa: undefined,
		confirmarEmailEmpresa: undefined,
		prefijoTelefonos,
		opcionesTieneBoleta: ['Sí', 'No'],
		opcionesTipoBoleta: ['Afecta', 'Exenta', 'Ambas (Afecta y Exenta)', 'Sin Boleta'],
		telefonoRepresentante: undefined,
		confirmarTelefonoRepresentante: undefined,
		confirmarEmailRepresentante: undefined,
		descripcionesArchivosAceptados: tiposArchivoAceptados.map(function(t) { return t.descripcion; }),
		mimeTypesArchivoAceptados: tiposArchivoAceptados.map(function(t) { return t.mimeType; }),
		direcciones: [],
		formularioValido: false,
	}),
	computed: {
		emailsIguales: function() {
			let vm = this;
			let emailEmpresa = vm.empresa.email;
			let emailRepresentante = vm.representante.email;
			let hayEmailEmpresa = (emailEmpresa !== undefined) && (emailEmpresa !== '');
			let hayEmailRepresentante = (emailRepresentante !== undefined) && (emailRepresentante !== '');
			let sonIguales = (emailEmpresa === emailRepresentante);
			return hayEmailEmpresa && hayEmailRepresentante && sonIguales;
		},
		telefonosIguales: function() {
			let vm = this;
			let telefonoEmpresa = vm.telefonoEmpresa;
			let telefonoRepresentante = vm.telefonoRepresentante;
			let hayTelefonoEmpresa = (telefonoEmpresa !== undefined) && (telefonoEmpresa !== '');
			let hayTelefonoRepresentante = (telefonoRepresentante !== undefined) && (telefonoRepresentante !== '');
			let sonIguales = (telefonoEmpresa === telefonoRepresentante);
			return hayTelefonoEmpresa && hayTelefonoRepresentante && sonIguales;
		},
		archivosCedulaParecenIguales: function() {
			let vm = this;
			let cedulaAnverso = vm.representante.cedulaAnverso;
			let cedulaReverso = vm.representante.cedulaReverso;
			let hayAnverso = (cedulaAnverso !== undefined) && (cedulaAnverso !== null);
			let hayReverso = (cedulaReverso !== undefined) && (cedulaReverso !== null);
			if(!hayAnverso || !hayReverso) {
				return false;
			}
			if(!cedulaAnverso || !cedulaReverso) {
				return false;
			}
			let pesosIguales = (cedulaAnverso.size === cedulaReverso.size);
			let nombresIguales = (cedulaAnverso.name === cedulaReverso.name);
			let parecenIguales = pesosIguales && nombresIguales;
			return parecenIguales;
		},
		cantidadAsociadaDirecciones: function() {
			let vm = this;
			let datosPlan = vm.datosPlan;
			return datosPlan ? datosPlan.plan.cantidadAsociadaDirecciones : false;
		},
		cantidad: function() {
			let vm = this;
			let datosPlan = vm.datosPlan;
			if(datosPlan === undefined) {
				return undefined;
			}
			let cantidad = datosPlan.cantidad;
			return cantidad;
		},
		hayDirecciones: function() {
			let vm = this;
			let direcciones = vm.direcciones;
			return (direcciones.length > 0);
		},
		esVentaAsistida: function() {
			let vm = this;
			let vendedorAsistente = vm.vendedorAsistente;
			let es = !!vendedorAsistente;
			return es;
		},
	},
	methods: {
		pegarEnConfirmacion: function(evento) {
			let vm = this;

			let esVentaAsistida = vm.esVentaAsistida;
			let puede = esVentaAsistida; // Puede sólo si es venta asistida
			if(puede) {
				// Proseguir
				return true;
			}
			else {
				// Evitar
				evento.preventDefault();
			}
		},
		getRegionesComunas: async function() {
			let vm = this;
			let apiName = config.autocontratarApiName;
			let path = '/regiones-comunas';
			let init = {
				headers: {},
			};
			vm.cargandoRegionesComunas = true;
			let response;
			try {
				response = await API.get(apiName, path, init);
				vm.regionesComunas = response.regiones;
			}
			catch(e) {
				vm.notificar('Error al leer regiones y comunas. Intente recargar esta página.', 'error');
			}
			vm.cargandoRegionesComunas = false;
		},
		notificar: function(mensaje, tipo) {
			let vm = this;
			vm.$emit('notificacion', {mensaje, tipo});
		},
		validarRut: function(v) {
			let rutRegex = /^(\d)+-([\d|kK])$/;
			if((v === undefined) || (v === '')) {
				return 'Debe definirse';
			}
			let calza = (v.match(rutRegex) !== null);
			if(!calza) {
				return 'Debe ser sin puntos y con guión. Ejemplo: 12345678-9';
			}
			let dvValido = RutJs.validate(v);
			return dvValido ? true : 'Dígito verificador inválido';
		},
		validarEmail: function(v) {
			//let emailRegex = /^.+\@.+\..+$/; // <-- despinoza 26-jul-2021: regex permite espacios!
			let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Versión un poco menos permisiva, véase https://ui.dev/validate-email-address-javascript/
			if((v === undefined) || (v === '')) {
				return 'Debe definirse';
			}
			let calza = (v.match(emailRegex) !== null);
			if(!calza) {
				return 'Formato incorrecto';
			}
			return true;
		},
		validarConfirmarEmailEmpresa: function(v) {
			let vm = this;
			if(v === undefined) {
				return 'Debe definirse';
			}
			return (v === vm.empresa.email) || 'No coinciden';
		},
		validarConfirmarEmailRepresentante: function(v) {
			let vm = this;
			if(v === undefined) {
				return 'Debe definirse';
			}
			return (v === vm.representante.email) || 'No coinciden';
		},
		validarDefinido: function(v) {
			if((v === undefined) || (v === '')) {
				return 'Debe definirse';
			}
			return true;
		},
		validarTelefono: function(v) {
			let telRegex = /^\d{9}$/;
			if((v === undefined) || (v === '')) {
				return 'Debe definirse';
			}
			let calza = (v.match(telRegex) !== null);
			if(!calza) {
				return 'Debe tener 9 dígitos';
			}
			return true;
		},
		validarConfirmarTelefonoEmpresa: function(v) {
			let vm = this;
			if(v === undefined) {
				return 'Debe definirse';
			}
			return (v === vm.telefonoEmpresa) || 'No coinciden';
		},
		validarConfirmarTelefonoRepresentante: function(v) {
			let vm = this;
			if(v === undefined) {
				return 'Debe definirse';
			}
			return (v === vm.telefonoRepresentante) || 'No coinciden';
		},
		validarArchivo: function(v) {
			let vm = this;
			if((v === undefined) || (v === null)) {
				return 'Debe definirse';
			}
			let pesoBytes = v.size;
			let pesoMaximoBytes = pesoMaximoArchivo;
			let pesoMinimoBytes = pesoMinimoArchivo;
			let demasiadoGrande = (pesoBytes > pesoMaximoBytes);
			let demasiadoPequeno = (pesoBytes < pesoMinimoArchivo);
			let mimeTypeAceptado = vm.mimeTypesArchivoAceptados.includes(v.type);
			let descripcionesArchivosAceptados = vm.descripcionesArchivosAceptados.join(', ');
			if(demasiadoGrande) {
				return `Archivo es demasiado grande. El máximo aceptado es ${(pesoMaximoBytes/(1024.0*1024.0)).toFixed(1)} Mib`;
			}
			if(demasiadoPequeno) {
				return `Archivo es demasiado pequeño. El mínimo aceptado es ${(pesoMinimoBytes/(1024.0)).toFixed(1)} Kib`;
			}
			if(!mimeTypeAceptado) {
				return `Archivo inválido, los tipos aceptados son: ${descripcionesArchivosAceptados}.`;
			}
			return true;
		},
		actualizarDirecciones: function(cantidadPlan, cantidadAsociadaDirecciones) {
			let vm = this;
			let numeroDireccionesNuevo = cantidadPlan;
			if(!cantidadAsociadaDirecciones || (numeroDireccionesNuevo === 0)) {
				// Vaciar el arreglo.
				vm.direcciones = [];
				return;
			}
			let numeroDireccionesActual = vm.direcciones.length;
			if(numeroDireccionesNuevo > numeroDireccionesActual) {
				// Si el número nuevo es mayor al actual, crear las que faltan
				let numeroDireccionesCrear = numeroDireccionesNuevo - numeroDireccionesActual;
				for(let i = 0; i < numeroDireccionesCrear; i++) {
					// Añadir objeto al arreglo
					vm.direcciones.push({
						direccion: undefined,
						region: undefined,
						comuna: undefined,
					});
				}
			}
			else if(numeroDireccionesNuevo < numeroDireccionesActual) {
				// Si el número nuevo es menor al actual, eliminar las sobrantes
				let numeroDireccionesEliminar = numeroDireccionesActual - numeroDireccionesNuevo;
				while(numeroDireccionesEliminar-- > 0) {
					// Extraer última dirección
					vm.direcciones.pop();
				}
			}
		},
		emitirDatos: function(valido) {
			// valido proviene de watch formularioValido
			let vm = this;
			let datos = {
				'empresa': vm.empresa,
				'representante': vm.representante,
				'direcciones': vm.direcciones,
			};
			vm.$emit('datos', valido, datos);
		},
		abrirDialogoArchivoCedulaAnverso: function() {
			let vm = this;
			// ADVERTENCIA, $refs.input.click() NO está documentado, en
			// futuras actualizaciones de Vuetify esto podría quebrarse.
			vm.$refs['inputCedulaAnverso'].$refs.input.click();
		},
		abrirDialogoArchivoCedulaReverso: function() {
			let vm = this;
			// ADVERTENCIA, $refs.input.click() NO está documentado, en
			// futuras actualizaciones de Vuetify esto podría quebrarse.
			vm.$refs['inputCedulaReverso'].$refs.input.click();
		},
		usarDireccionComercial: function() {
			let vm = this;
			let empresa = vm.empresa;
			let direccion = empresa.direccion;
			let region = empresa.region;
			let comuna = empresa.comuna;
			let direcciones = vm.direcciones;
			if(direcciones.length < 1) {
				throw 'No hay direcciones para copiar los datos de la dirección comercial';
			}
			let primeraDireccion = direcciones[0];
			primeraDireccion.direccion = direccion;
			primeraDireccion.region = region;
			primeraDireccion.comuna = comuna;
		},
		prellenar: function(datosPrellenado) {
			let vm = this;
			let empresa = vm.empresa;
			let representante = vm.representante;
			let datosClientePrellenado = datosPrellenado.cliente;
			if(datosClientePrellenado) {
				// PRECAUCION esta rutina es muy frágil, surgió luego de que este formulario
				// ya era complejo. Por cada campo de formulario, se verá si viene el dato
				// para prellenar, se validará, y si es válido, se colocará en el campo.
				let mapeo = [
					// Datos empresa
					{ 'llaveOrigen': 'empresaRut', 'destino': empresa, 'llaveDestino': 'rut', 'validar': vm.validarRut },
					{ 'llaveOrigen': 'empresaRazonSocial', 'destino': empresa, 'llaveDestino': 'razonSocial', 'validar': vm.validarDefinido },
					{ 'llaveOrigen': 'empresaGiroComercial', 'destino': empresa, 'llaveDestino': 'giroComercial', 'validar': vm.validarDefinido },
					{ 'llaveOrigen': 'empresaEmail', 'destino': empresa, 'llaveDestino': 'email', 'validar': vm.validarEmail },
					{ 'llaveOrigen': 'empresaEmail', 'destino': vm, 'llaveDestino': 'confirmarEmailEmpresa', 'validar': vm.validarConfirmarEmailEmpresa },
					{ 'llaveOrigen': 'empresaTelefono', 'destino': vm, 'llaveDestino': 'telefonoEmpresa', 'validar': vm.validarTelefono },
					{ 'llaveOrigen': 'empresaTelefono', 'destino': vm, 'llaveDestino': 'confirmarTelefonoEmpresa', 'validar': vm.validarConfirmarTelefonoEmpresa },
					// Datos representante
					{ 'llaveOrigen': 'representanteRut', 'destino': representante, 'llaveDestino': 'rut', 'validar': vm.validarRut },
					// NOTA: No es posible hacerlo mejor con los nombres, no vienen estructurados
					{ 'llaveOrigen': 'representanteNombreCompleto', 'destino': representante, 'llaveDestino': 'nombres', 'validar': vm.validarDefinido },
					{ 'llaveOrigen': 'representanteEmail', 'destino': representante, 'llaveDestino': 'email', 'validar': vm.validarEmail },
					{ 'llaveOrigen': 'representanteEmail', 'destino': vm, 'llaveDestino': 'confirmarEmailRepresentante', 'validar': vm.validarConfirmarEmailRepresentante },
					{ 'llaveOrigen': 'representanteTelefono', 'destino': vm, 'llaveDestino': 'telefonoRepresentante', 'validar': vm.validarTelefono },
					{ 'llaveOrigen': 'representanteTelefono', 'destino': vm, 'llaveDestino': 'confirmarTelefonoRepresentante', 'validar': vm.validarConfirmarTelefonoRepresentante },
				];

				mapeo.forEach( campo => {
					// Tomar valor de origen
					const valorOrigen = datosClientePrellenado[campo.llaveOrigen];
					// Ver si es válido
					const esValido = (campo.validar(valorOrigen) === true);
					if(esValido) {
						// Si es válido, asignarlo al destino
						campo.destino[campo.llaveDestino] = valorOrigen;
					}
				});
			}
		},
	},
	mounted: function() {
		let vm = this;
		vm.getRegionesComunas();
		vm.actualizarDirecciones(vm.cantidad, vm.cantidadAsociadaDirecciones);
	},
	watch: {
		telefonoEmpresa: function(newVal) {
			let vm = this;
			if(newVal === undefined) {
				return;
			}
			vm.empresa.telefono = `${prefijoTelefonos}${newVal}`;
		},
		telefonoRepresentante: function(newVal) {
			let vm = this;
			if(newVal === undefined) {
				return;
			}
			vm.representante.telefono = `${prefijoTelefonos}${newVal}`;
		},
		cantidadAsociadaDirecciones: {
			immediate: true, // Necesario para computed que usan prop
			handler: function(newVal) {
				let vm = this;
				vm.actualizarDirecciones(vm.cantidad, newVal);
			},
		},
		cantidad: {
			immediate: true, // Necesario para computed que usan prop
			handler: function(newVal) {
				let vm = this;
				vm.actualizarDirecciones(newVal, vm.cantidadAsociadaDirecciones);
			},
		},
		formularioValido: function(newVal) {
			let vm = this;
			let cargandoDatosPrellenado = vm.cargandoDatosPrellenado;
			// Puede que formulario sea válido pero que después se pise con algunos datos
			// que deban ser corregidos, no dar por válido aún si se están cargando los datos
			// a prellenar.
			let valido = (newVal && !cargandoDatosPrellenado);
			vm.emitirDatos(valido);
		},
		cargandoDatosPrellenado: function(newVal) {
			let vm = this;
			let formularioValido = vm.formularioValido;
			let valido = (newVal && !formularioValido);
			vm.emitirDatos(valido);
		},
		datosPrellenado: {
			immediate: true, // Necesario para computed que usan prop
			handler: function(newVal, oldVal) {
				let vm = this;
				// De momento solo reaccionar a cuando adquiere un valor.
				// Sólo se cargará una vez la información a prellenar.
				if(!oldVal && newVal) {
					vm.prellenar(newVal);
				}
			},
		},
	}
};
</script>
